$(document).ready(function(){
    $(".owl-single").owlCarousel({
        center: true,
        items: 1,
        loop: true,
        autoplay:true,
        autoplayTimeout:6000,
        autoplayHoverPause:true,
        nav: true,
        navText: ['<i class="fa-thin fa-2x fa-angle-left" aria-hidden="true"></i>','<i class="fa-thin fa-2x fa-angle-right" aria-hidden="true"></i>']
    });

    $(".owl-list").owlCarousel({
        center: true,
        items: 1,
        loop: true,
        autoplay:false,
        nav: true,
        navText: ['<i class="fa-thin fa-2x fa-chevron-square-left"></i>','<i class="fa-thin fa-2x fa-chevron-square-right"></i>'],
        dots: false
    });

    $(".owl-full").owlCarousel({
        navigation : true,
        items: 1,
        animateOut: 'fadeOut',
        slideSpeed : 300,
        paginationSpeed : 400,
        pagination: false,
        rewindSpeed: 500,
        dots: false
    });

    $(".owl-webzine").owlCarousel({
        center: true,
        loop: true,
        autoWidth:true,
        autoplay: false,
        autoplayTimeout: 6000,
        autoplayHoverPause:true,
        dots: false,
        nav: false,
        responsive:{
            0:{
                items:1,
                loop: false
            },
            1000:{
                items:3,
                loop:true
            }
        }
    });




    //https://codepen.io/gjk/pen/BpyYoj
    $('.story-owl').owlCarousel({
        items: 1,
        autoplay: true,
        loop: true,
        margin: 0,
        nav: false,
        dots: false,
        lazyLoad: true,
        animatein: 'fadeOut',
        animateOut: 'fadeOut',
        pagination: false,
        onInitialized: startProgressBar,
        onTranslate: resetProgressBar,
        onTranslated: startProgressBar
    });

    function fixOwlCurrentIdx(event) {
        let current = (event.item.index + 1) - event.relatedTarget._clones.length / 2;
        let itemsCount = event.item.count;

        if (current > itemsCount || current == 0) {
            current = itemsCount - (current % itemsCount);
        }

        return current - 1;
    }

    function startProgressBar(event) {
        var element = event.target; // DOM element, in this example .owl-carousel
        var items = event.item.count; // Number of items
        // var item = event.item.index; // Position of the current item
        var item = fixOwlCurrentIdx(event); // https://jsfiddle.net/yunusga/4zvpns6j/
        // console.log('item:' + item + ' items:' + items)

        var pourcent = 96 / items;
        var itemWidth = pourcent - 1;
        var itemLeft = (item * pourcent) + 2.5;

        if (item + items == items) {
            $('.slide-progress').removeClass('active');
        }

        // apply keyframe animation
        $(".current-slide-progress").css({
            left: itemLeft + "%",
            width: itemWidth + "%",
            transition: "width 5000ms"
        });
    }

    function resetProgressBar(event) {
        $(".current-slide-progress").css({
            width: 0,
            transition: "width 0s"
        });
        var item = fixOwlCurrentIdx(event) - 1;
        $('.slides-progress').children().eq(item).addClass('active');
    }

});